import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import { useScopeStore } from '@/stores/scope'

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login.vue'),
    meta: { public: true }
  },
  {
    path: '/open/evaluate',
    name: 'open-evaluate',
    component: () => import('@/views/observe/OpenEvaluatePage.vue'),
    meta: { public: true, title: '公开课评课填写' }
  },
  {
    path: '/',
    component: () => import('@/layout/AppLayout.vue'),
    redirect: () => {
      // 登录落地页差异化：普通用户落在"我的待办"，管理角色落在"数据看板"
      const auth = useAuthStore()
      const role = auth.currentRole
      const manage = ['ADMIN', 'HEAD_TEACHING', 'HEAD_PREP', 'LEADER']
      return manage.includes(role) ? '/dashboard' : '/todo'
    },
    children: [
      { path: 'dashboard', name: 'dashboard', component: () => import('@/views/dashboard/Dashboard.vue'), meta: { title: '数据看板' } },
      { path: 'todo', name: 'todo', component: () => import('@/views/todo/TodoCenter.vue'), meta: { title: '我的待办' } },
      { path: 'lesson-plans', name: 'lesson-plans', component: () => import('@/views/lesson/LessonPlanManage.vue'), meta: { title: '备课管理' } },
      { path: 'observe', name: 'observe', component: () => import('@/views/observe/ObserveManage.vue'), meta: { title: '听课评课' } },
      { path: 'questions', name: 'questions', component: () => import('@/views/question/QuestionManage.vue'), meta: { title: '题库与组卷' } },
      { path: 'questions/create', name: 'question-create', component: () => import('@/views/question/QuestionEdit.vue'), meta: { title: '录入题目' } },
      { path: 'questions/batch-input', name: 'question-batch-input', component: () => import('@/views/question/BatchQuestionInput.vue'), meta: { title: '批量录入题目' } },
      { path: 'questions/:id/edit', name: 'question-edit', component: () => import('@/views/question/QuestionEdit.vue'), meta: { title: '编辑题目' } },
      { path: 'exam-templates', name: 'exam-templates', component: () => import('@/views/exam/ExamTemplateManage.vue'), meta: { title: '组卷模板' } },
      { path: 'exam-papers', name: 'exam-papers', component: () => import('@/views/exam/ExamPaperList.vue'), meta: { title: '试卷列表' } },
      { path: 'exam-papers/:id', name: 'exam-paper-detail', component: () => import('@/views/exam/ExamPaperDetail.vue'), meta: { title: '试卷详情' } },
      { path: 'exam-batches', name: 'exam-batches', component: () => import('@/views/exam/ExamBatchManage.vue'), meta: { title: '集中组卷' } },
      { path: 'knowledge-points', name: 'knowledge-points', component: () => import('@/views/knowledge/KnowledgeManage.vue'), meta: { title: '知识点体系' } },
      { path: 'admin', name: 'admin', component: () => import('@/views/admin/AdminManage.vue'), meta: { title: '系统管理' } },
      { path: 'upload-limit', name: 'upload-limit', component: () => import('@/views/admin/AdminUploadLimit.vue'), meta: { title: '容量配置' } },
      { path: 'profile', name: 'profile', component: () => import('@/views/UserProfile.vue'), meta: { title: '个人信息' } },
      { path: 'change-password', name: 'change-password', component: () => import('@/views/ChangePassword.vue'), meta: { title: '修改密码' } },
      { path: 'calendar', name: 'calendar', component: () => import('@/views/calendar/Calendar.vue'), meta: { title: '校历' } },
      { path: 'feedback', name: 'feedback', component: () => import('@/views/feedback/MyFeedback.vue'), meta: { title: '问题与建议' } },
      { path: 'help', name: 'help', component: () => import('@/views/help/HelpCenter.vue'), meta: { title: '帮助中心' } }
    ]
  },
  { path: '/:pathMatch(.*)*', redirect: '/dashboard' }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach(async (to) => {
  const auth = useAuthStore()
  if (!to.meta.public && !auth.isLoggedIn) {
    return { name: 'login' }
  }
  if (to.name === 'login' && auth.isLoggedIn) {
    return { path: '/' }
  }
  // 登录态下首次加载数据范围（/api/user/me），供知识点等页面判定可写/只读；失败由拦截器统一提示
  if (auth.isLoggedIn) {
    try {
      await useScopeStore().ensureLoaded()
    } catch (e) {
      /* 忽略：响应拦截器已提示 */
    }
  }
})

export default router
